import React, { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from 'reactstrap';

import classNames from 'classnames';

import confirm from 'Demora/modals/confirm';

import socialHttp from '../../../../../utils/socialHttp';

import feedActions from 'resources/assets/react-app/uiHooks/react-social/feedActions';

import asyncComponent from 'Demora/AsyncComponent';

var NewCommentBox = asyncComponent(
	() =>
		import(/* webpackChunkName: "new_Comment_box" */ '../Posts/NewCommentBox')
);

var NewPostBox = asyncComponent(
	() => import(/* webpackChunkName: "new_Post_box" */ '../Posts/NewPostBox')
);

import modal from 'Demora/modals/modal';

import GroupItemActions from '../../Groups/GroupItemActions';

class FeedItemActions extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			dropdownOpen: false,
		};
	}

	confirmDeletion(type, block) {
		const { user, post } = this.props;

		let postUser = this.props.users[post.u + '-u'];

		let message = [];

		if (type == 'r' || type == 'd') {
			let m =
				(type == 'r' ? 'report' : 'delete') +
				' ' +
				(postUser.id == user.id ? 'your' : postUser.first_name + "'s");

			if (post.m.m) {
				let t1 = post.m.m.substr(0, 100);

				let lastSpace = t1.lastIndexOf(' ');

				if (lastSpace == -1) {
					lastSpace = t1.length;
				}

				let txt = t1.substr(0, Math.min(t1.length, lastSpace));

				if (txt.length < post.m.m.length) {
					txt += '...';
				}

				m += ' post "' + txt + '"';
			}
			if (post.m.s) {
				m += ' share';
			}

			message.push(m);
		}

		if (type == 'remove') {
			message.push(' remove ' + postUser.first_name);
		}

		if (block) {
			message.push('block ' + postUser.first_name);
		}

		message = 'Are you sure you want to ' + message.join(' and ') + '?';

		if (Object.keys(post.can).length === 0) {
			return null;
		}

		confirm({
			id: 'deletePost',
			header: 'Confirm',
			message: message,
			confirmButtonText: 'Yes!',
			confirmFunc: this.deleteReportPost.bind(this, type, block),
		});
	}

	deleteReportPost(type, block) {
		socialHttp('delete', '/data/feed/' + this.props.post.id, {
			b: block,
			t: type,
		}).catch((e) => {
			throw e;
		});
	}

	toggle = () => {
		this.setState((prevState) => ({
			dropdownOpen: !prevState.dropdownOpen,
		}));
	};

	copyandedit(post) {
		let type = 'post';

		if (post.id.split('-')[3]) {
			type = 'comment';
		}

		modal({
			id: 'edit_post',
			header: 'Copy and Edit',
			noFooter: true,
			body: (
				<div>
					<h6 className='text-center'>
						You can edit the {type} below. This will create a new {type}.
					</h6>

					{type == 'post' ? (
						<NewPostBox
							text={post.m.m}
							images={post.m.i}
							onSave={this.closeModal}
							obj={post.id.split('-').slice(0, 2).join('-')}
							maxRows={10}
						/>
					) : (
						<NewCommentBox
							post={post}
							text={post.m.m}
							images={post.m.i}
							onSave={this.closeModal}
							maxRows={10}
						/>
					)}
				</div>
			),
			className: 'modal-max900-width',
		});
	}

	closeModal = () => {
		modal.close('edit_post');
	};

	render() {
		const props = this.props;

		if (!props.user.id) {
			return null;
		}

		const post = props.post;

		const user = props.user;

		let buttons = [];

		post.can.d &&
			buttons.push({
				type: 'd',
				label: 'Delete post',
			});

		post.can.d &&
			post.can.b &&
			buttons.push({
				type: 'd',
				block: true,
				label: 'Delete post and block user',
			});

		post.can.r &&
			buttons.push({
				type: 'r',
				label: 'Report post',
			});

		post.can.r &&
			post.can.b &&
			buttons.push({
				type: 'r',
				block: true,
				label: 'Report post and block user',
			});

		post.can.b &&
			buttons.push({
				block: true,
				label: 'Block user',
			});

		const pid = post.id.split('-');

		pid[1] == 'g' &&
			parseFloat(props.feed[pid.slice(0, 2).join('-')].role) == 255 &&
			post.can.b &&
			buttons.push({
				type: 'remove',
				label: 'Remove user',
			});

		buttons = buttons.map((b, k) => {
			return (
				<DropdownItem
					key={k}
					onClick={this.confirmDeletion.bind(this, b.type, b.block)}
				>
					{b.label}
				</DropdownItem>
			);
		});

		buttons.unshift(
			<DropdownItem key={'header'} header>
				Delete/Report
			</DropdownItem>
		);

		if (user.id == post.u && post.m && (post.m.m || post.m.i)) {
			buttons.unshift(
				<DropdownItem
					key={'copy/edit2'}
					onClick={this.copyandedit.bind(this, post)}
				>
					Copy and Edit Post
				</DropdownItem>
			);

			buttons.unshift(
				<DropdownItem key={'copy/edit1'} header>
					Edit Post
				</DropdownItem>
			);
		}

		const b = {
			100: buttons,
		};

		const extraFeedActions = feedActions(props.post);

		const indexes = {};

		Object.keys(b).map((b1) => {
			indexes[b1] = 1;
		});

		Object.keys(extraFeedActions).map((b1) => {
			indexes[b1] = 1;
		});

		let dropDownItems = [];

		Object.keys(indexes)
			.sort((a, b) => {
				return a - b;
			})
			.map((k) => {
				if (b[k]) {
					dropDownItems = dropDownItems.concat(b[k]);
				}

				if (extraFeedActions[k]) {
					dropDownItems = dropDownItems.concat(extraFeedActions[k]);
				}
			});

		if (post.id.split('-')[1] == 'g') {
			dropDownItems.concat(
				<GroupItemActions post={post} complete={this.toggle} />
			);
		}

		return (
			<Dropdown
				isOpen={this.state.dropdownOpen}
				toggle={this.toggle}
				className={classNames('float-right', props.className)}
				direction='left'
			>
				<DropdownToggle className='btn-link' tag='a'>
					{props.triggerLabel ?? <i className='fas fa-ellipsis-h'></i>}
				</DropdownToggle>

				{this.state.dropdownOpen && (
					<DropdownMenu>{dropDownItems}</DropdownMenu>
				)}
			</Dropdown>
		);
	}
}

export default ReduxConnect(FeedItemActions, {
	user: 'user',
	users: 'users',
	toastr: 'toastr',
	feed: 'feed',
});
